export enum UserType {
    Athlete = 1,
    Coach = 2,
    Admin = 3,
}
